// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#subTabSetOnly[data-v-2b1d3d45] {
  padding-right: 15px;
  padding-left: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-router-toptabs.vue","webpack://./np-router-toptabs.vue"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,kBAAA;ACAR","sourcesContent":["\n    #subTabSetOnly {\n        padding-right: 15px;\n        padding-left: 15px;\n    }\n","#subTabSetOnly {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
